import React from "react";
import { useCustomerModel } from "../customerModel";
import { ISearchValue, SearchTypeEnum } from "@/components/YhPageHeader/Types";
import { YhPageHeader } from "@/components/YhPageHeader";
import { useDictModel } from "../../dict/dictModel";
import { DictCodeEnmu } from "@/types/AppDictEnums";


export function PageHeader() {
    const {
        searchParam,
        updateSearchParam,
        resetSearchParam,
        loadData
    } = useCustomerModel();
    const { getSelectedDictOne } = useDictModel(() => []);
    const searchFields = [
        {
            type: SearchTypeEnum.Input,
            placeholder: "客户编号",
            fieldName: "code"
        },
        {
            type: SearchTypeEnum.Input,
            placeholder: "联系人",
            fieldName: "contact"
        },
        {
            type: SearchTypeEnum.Input,
            placeholder: "客户名称",
            fieldName: "name",
        },
        {
            type: SearchTypeEnum.Select,
            placeholder: "贸易国别",
            fieldName: "countryCode",
            options: getSelectedDictOne(DictCodeEnmu.COUNTRY)
        },
        // {
        //     type: SearchTypeEnum.Datepicker,
        //     placeholder: "创建时间",
        //     fieldName: "createTime"
        // }
    ]


    return (
        <YhPageHeader
            title="客户管理"
            size="small"
            justify="end"
            searchValues={searchParam as ISearchValue}
            searchFields={searchFields}
            onChange={updateSearchParam}
            triggerSearch
            handleSearch={(val = {}) => loadData({ pageNum: 1 }, { ...searchParam, ...val })}
            handleReset={resetSearchParam}
        />
    );
}